import React from 'react';
import {Query} from 'models/api';
import EventEmitter from 'EventEmitter';

export interface RouterData {
    page: string;
    pathname: string;
    query: Query;
    hash?: string;
    as: string;
    hostname: string;
    events?: EventEmitter;
}

export default React.createContext<RouterData>({} as RouterData);
